import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=28baef5c&"
import script from "./tabla.vue?vue&type=script&lang=js&"
export * from "./tabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports